// src/lib/defaultContext.js
//
// El contexto en el que aterrizas al entrar. Es el "Default Team" de Vercel, y
// hace falta por la misma razón: con ocho contextos en el switcher, abrir la app
// en el que toque no es un detalle, es empezar cada sesión desorientado.
//
// Vive en localStorage y no en el backend a propósito: es una preferencia del
// dispositivo, no del usuario, y no bloquea nada mientras el backend no la tenga.
// Se lee **solo** cuando no hay contexto persistido —sesión nueva o
// almacenamiento limpio—, para no pisar el contexto en el que estabas.
const KEY = 'zenit.defaultContext';

export function readDefaultContext() {
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null; // modo privado: la app funciona, solo no recuerda
  }
}

// "Personal" se guarda explícitamente en vez de borrar la clave: sin eso no hay
// forma de distinguir «prefiero personal» de «nunca elegí», y hoy el arranque
// salta a la primera organización de la lista cuando no hay preferencia.
export function writeDefaultContext(context) {
  try {
    if (!context) window.localStorage.removeItem(KEY);
    else window.localStorage.setItem(KEY, JSON.stringify(context));
  } catch {
    /* idem */
  }
}
